module.exports = __webpack_public_path__ + "img/menu.4d04b20b.svg";